var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHammerHeartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5577 32.9222L31.6244 31.1622C24.7577 24.9356 20.2244 20.8289 20.2244 15.7889C20.2244 11.6822 23.451 8.45557 27.5577 8.45557C29.8777 8.45557 32.1044 9.53557 33.5577 11.2422C35.011 9.53557 37.2377 8.45557 39.5577 8.45557C43.6644 8.45557 46.891 11.6822 46.891 15.7889C46.891 20.8289 42.3577 24.9356 35.491 31.1756L33.5577 32.9222Z",
    fill: "url(#paint0_linear_304_1384)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64451 8.03105L9.92283 7.05235L12.5114 8.31471L13.1743 10.2402L20.293 13.7115L17.1371 20.1829L14.6095 18.9503C14.585 19.0779 14.5435 19.2044 14.4838 19.3268L7.42419 33.8033C7.06107 34.5479 6.16309 34.8571 5.41848 34.494C4.67387 34.1309 4.36462 33.2329 4.72774 32.4883L11.7874 18.0118C11.8471 17.8894 11.9212 17.7788 12.0067 17.681L10.0185 16.7114L8.09319 17.3747L5.50458 16.1124L5.48861 14.5025L8.64451 8.03105Z",
    fill: "#808080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8071 14.311L22.2185 13.0486L20.293 13.7115L17.1371 20.1829L17.8003 22.1086L20.3888 23.371L24.8071 14.311Z",
    fill: "#808080"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8071 14.311L24.8232 15.9209L21.6673 22.3924L20.3888 23.371L24.8071 14.311Z",
    fill: "#808080"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_304_1384",
    x1: 46.891,
    y1: 20.6889,
    x2: 20.2244,
    y2: 20.6889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5576C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F093FB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHammerHeartIcon);
export default __webpack_public_path__ + "static/media/HammerHeartIcon.a26b1d3e9bec6667c46f888c5b69611c.svg";
export { ForwardRef as ReactComponent };